/**
 * Needed quiz — vplans variant.
 */
(function (Q) {
  const { state, depletionScore, IMG, el } = Q.deps();
  const planBenefits = {
    egg_freezing_ivf: [
      'Prenatal Multivitamin — 22 nutrients at clinically studied dosages',
      'Omega-3 — 1,000mg DHA+EPA for egg quality & future brain development',
      'Egg Quality Support — targeted antioxidants for egg health',
      'CoQ10 — mitochondrial energy support for egg development',
    ],
    transfer_prep: [
      'Prenatal Multivitamin — 22 nutrients at clinically studied dosages',
      'Omega-3 — 1,000mg DHA+EPA to support implantation',
      'Egg Quality Support — antioxidant support for the transfer window',
    ],
    ttc: [
      'Prenatal Multivitamin — 22 nutrients at clinically studied dosages',
      'Omega-3 — 1,000mg DHA+EPA, loaded 90+ days before conception',
      'Egg Quality Support — antioxidants to optimize egg health',
    ],
    pregnant: [
      'Prenatal Multivitamin — 22 nutrients at clinically studied dosages',
      'Prenatal Iron — glycinate-bound for gentler digestion',
      "Omega-3 — 1,000mg DHA+EPA for your baby's brain development",
    ],
    pregnant_powder: [
      'Prenatal Multivitamin Powder — 22 nutrients in one daily scoop',
      'Prenatal Iron — glycinate-bound, dosed separately for better absorption',
      "Omega-3 — 1,000mg DHA+EPA for your baby's brain development",
    ],
    pregnant_pro: [
      'Prenatal Multivitamin Pro — 26 nutrients at clinically studied dosages',
      'Prenatal Iron — glycinate-bound for gentler digestion',
      "Omega-3 — 1,000mg DHA+EPA for your baby's brain development",
    ],
    postpartum: [
      'Prenatal Multivitamin — 22 nutrients at clinically studied dosages',
      'Omega-3 — 1,000mg DHA+EPA for mood, recovery & breastmilk quality',
      'Stress Support — clinically studied ashwagandha + saffron for recovery',
    ],
    multi_only: [
      'Prenatal Multivitamin — 22 nutrients at clinically studied dosages',
      'Methylated folate (L-5-MTHF) & choline 200mg',
      'Clinically studied dosages — 3rd-party tested',
    ],
  };

  function getPlanBenefits(plan) {
    return planBenefits[plan.id] || planBenefits.multi_only;
  }

  function recommendedPlan() {
  const a = state.answers;
  const score = depletionScore();
  const wantsPowder = a.formatPreference === 'powder' || a.formatPreference === 'pills_hard';
  const nausea = a.symptoms.includes('nausea');
  const useFormat = wantsPowder || (nausea && a.formatPreference !== 'capsules_fine') ? 'powder' : 'capsule';
  const formatLabel = useFormat === 'powder' ? 'Powder' : '3-cap';

  // ── Multi-only shortcut ──
  const ironCovered = a.ironStatus === 'in_range';
  const dhaCovered  = a.dhaIntake === 'twice_weekly';
  if (ironCovered && dhaCovered) {
    return {
      id: 'multi_only',
      tag: 'Nutritional Foundation',
      name: useFormat === 'powder' ? 'Prenatal Multivitamin Powder' : 'Prenatal Multivitamin',
      price: '$42.99', cadence: '/ month',
      components: ['Prenatal Multi (' + formatLabel + ')'],
      headline: "You're ahead on iron and omega-3 — let's get the foundation right.",
      sub: 'Your fish intake covers DHA and your iron is already in range. The 22-nutrient Prenatal Multivitamin is the right starting point.',
      url: useFormat === 'powder' ? 'https://thisisneeded.com/products/prenatal-multi-powder' : 'https://thisisneeded.com/products/prenatal-multi-essentials',
      image: useFormat === 'powder' ? IMG.multi_powder : IMG.multi_capsule,
    };
  }

  // ── Egg Freezing (post-retrieval) → Women's Fertility Support Plan ──
  if (a.lifestage === 'egg_freezing' && a.stageDetail === 'egg_freezing_post') {
    return {
      id: 'transfer_prep',
      tag: 'For transfer preparation',
      name: "Women's Fertility Support Plan" + (useFormat === 'powder' ? ' (Powder)' : ''),
      price: '$111', cadence: '/ month',
      components: ['Prenatal Multi (' + formatLabel + ')', 'Omega-3', 'Egg Quality Support'],
      headline: 'Your transfer window is your preparation window.',
      sub: "The nutrients you load now become the foundation your embryo implants into.",
      url: 'https://thisisneeded.com/products/fertility-support-plan',
      image: useFormat === 'powder' ? IMG.ttc_powder : IMG.ttc,
    };
  }

  // ── Egg Freezing → Egg Freezing & IVF Support Plan ──
  if (a.lifestage === 'egg_freezing') {
    return {
      id: 'egg_freezing_ivf',
      tag: 'For egg freezing & IVF',
      name: 'Egg Freezing & IVF Support Plan' + (useFormat === 'powder' ? ' (Powder)' : ''),
      price: '$156', cadence: '/ month',
      components: ['Prenatal Multi (' + formatLabel + ')', 'Omega-3', 'Egg Quality Support', 'CoQ10'],
      headline: 'You have a 90-day window to optimize the eggs you\'ll freeze.',
      sub: 'Egg cell maturation takes 3–4 months. The nutrients you load now are the nutrients those cells use to develop.',
      url: 'https://thisisneeded.com/products/egg-freezing-ivf-support-plan',
      image: useFormat === 'powder' ? IMG.egg_freezing_p : IMG.egg_freezing,
    };
  }

  // ── TTC → Women's Fertility Support Plan ──
  if (a.lifestage === 'ttc') {
    return {
      id: 'ttc',
      tag: 'For trying to conceive',
      name: "Women's Fertility Support Plan" + (useFormat === 'powder' ? ' (Powder)' : ''),
      price: '$111', cadence: '/ month',
      components: ['Prenatal Multi (' + formatLabel + ')', 'Omega-3', 'Egg Quality Support'],
      headline: 'Your nutrient stores at conception become your baby\'s foundation.',
      sub: 'Folate, choline, DHA, and antioxidants need to be optimized 90+ days before a positive test.',
      url: 'https://thisisneeded.com/products/fertility-support-plan',
      image: useFormat === 'powder' ? IMG.ttc_powder : IMG.ttc,
    };
  }

  // ── Postpartum → Postnatal Vitamins Plan ──
  if (a.lifestage === 'postpartum') {
    return {
      id: 'postpartum',
      tag: 'For postpartum & breastfeeding',
      name: 'Postnatal Vitamins Plan' + (useFormat === 'powder' ? ' (Powder)' : ''),
      price: '$111', cadence: '/ month',
      components: ['Prenatal Multi (' + formatLabel + ')', 'Omega-3', 'Stress Support'],
      headline: 'Your body just did the most extraordinary thing. It\'s running on empty.',
      sub: 'Pregnancy and breastfeeding can drain maternal nutrient stores by 30–40%. Replenishment isn\'t a luxury — it\'s recovery.',
      url: 'https://thisisneeded.com/products/postnatal-vitamins-plan',
      image: useFormat === 'powder' ? IMG.postnatal_powder : IMG.postnatal,
    };
  }

  // ── Pregnant Pro-eligible + powder → Iron+DHA Powder + "more support" → Pro ──
  const proEligible = (a.currentPrenatal === 'rx') || (score >= 8 && (a.formatPreference === 'capsules_fine' || a.formatPreference === 'whatever'));
  if (proEligible && useFormat === 'powder') {
    return {
      id: 'pregnant_powder',
      tag: 'For pregnancy',
      name: 'Prenatal Vitamins with Iron + DHA (Powder)',
      price: '$85', cadence: '/ month',
      components: ['Prenatal Multi (Powder)', 'Iron', 'Omega-3'],
      headline: nausea ? "You shouldn't have to choose between a prenatal that works and one you can actually take." : 'A complete pregnancy stack — in one daily scoop.',
      sub: '8x more nutrition than leading prenatals in 22 nutrients at clinically studied dosages.†',
      url: 'https://thisisneeded.com/products/prenatal-vitamins-iron-dha',
      image: IMG.iron_dha_powder,
      moreSupport: {
        name: 'Prenatal Vitamins with Iron + DHA Pro',
        price: '$85', cadence: '/ month',
        desc: 'Upgrade to Multi Pro — 26 nutrients including Choline, Magnesium, Calcium, Lutein & Zeaxanthin on top of the core formula.',
        url: 'https://thisisneeded.com/products/prenatal-vitamins-iron-dha-pro',
        image: IMG.iron_dha_pro,
      },
    };
  }

  // ── Pregnant Pro-eligible (capsule) → Prenatal Vitamins with Iron + DHA Pro ──
  if (proEligible) {
    return {
      id: 'pregnant_pro',
      tag: a.currentPrenatal === 'rx' ? 'Clinical-grade upgrade' : 'High-density formula',
      name: 'Prenatal Vitamins with Iron + DHA Pro',
      price: '$85', cadence: '/ month',
      components: ['Prenatal Multi Pro (8-cap)', 'Iron', 'Omega-3'],
      headline: a.currentPrenatal === 'rx'
        ? "You're already used to a clinical standard. Here's what actually meets it."
        : "You're sitting in the heart of the depletion problem — let's overcorrect.",
      sub: a.currentPrenatal === 'rx'
        ? 'Most Rx prenatals are formulated to meet outdated minimums. Multi Pro delivers 26 nutrients at clinically studied doses.'
        : 'Multi Pro adds Choline, Magnesium, Calcium, Lutein, and Zeaxanthin on top of the 22 nutrients in our core Multi.',
      url: 'https://thisisneeded.com/products/prenatal-vitamins-iron-dha-pro',
      image: IMG.iron_dha_pro,
    };
  }

  // ── Pregnant (all other) → Prenatal Vitamins with Iron + DHA ──
  return {
    id: 'pregnant',
    tag: 'For pregnancy',
    name: useFormat === 'powder' ? 'Prenatal Vitamins with Iron + DHA (Powder)' : 'Prenatal Vitamins with Iron + DHA',
    price: '$85', cadence: '/ month',
    components: ['Prenatal Multi (' + formatLabel + ')', 'Iron', 'Omega-3'],
    headline: nausea
      ? "You shouldn't have to choose between a prenatal that works and one you can actually take."
      : 'Your prenatal is being shortchanged in more ways than one.',
    sub: '8x more nutrition than leading prenatals in 22 nutrients at clinically studied dosages.†',
    url: 'https://thisisneeded.com/products/prenatal-vitamins-iron-dha',
    image: useFormat === 'powder' ? IMG.iron_dha_powder : IMG.iron_dha,
  };
}


  function appendResultMerchandising(card, plan) {
      // ── Add-ons ──
        // ── "More support" — only for pregnant powder → Pro upgrade ──
      if (plan.moreSupport) {
        const ms = plan.moreSupport;
        const moreBlock = el('div', { class: 'result-bundle-upsell' });
        if (ms.image) {
          const msImgCard = el('div', { class: 'result-bundle-img-card' });
          const msImg = el('img', { src: ms.image, alt: ms.name, loading: 'eager', class: 'result-bundle-img' });
          msImg.onerror = () => { msImgCard.style.display = 'none'; };
          msImgCard.appendChild(msImg);
          moreBlock.appendChild(msImgCard);
        }
        moreBlock.appendChild(el('div', { class: 'result-bundle-heading' }, 'Looking for more support?'));
        const msDesc = el('p', { class: 'result-bundle-desc' });
        msDesc.innerHTML = '<strong>' + ms.name + '</strong> · From <strong>' + ms.price + '</strong>/month — ' + ms.desc;
        moreBlock.appendChild(msDesc);
        moreBlock.appendChild(NeededQuizCart.createButton({ className: 'btn result-bundle-btn', text: 'Add Pro Plan to Cart →', url: ms.url }));
        card.appendChild(moreBlock);
      }
  }

  if (!Q) {
    console.error('[needed-quiz] Load needed-quiz-core.js before needed-quiz-vplans.js');
    return;
  }

  Q.register({ recommendedPlan, getPlanBenefits, appendResultMerchandising });
})(window.NeededQuizCore);
